import { useTimeTableColor } from '../state/storeTimeTableColor';

export const useGetMetaThemeColors = () => {
	const updateFirstBG = useTimeTableColor( ( state ) => state.updateFirstBG );
	const updateFirstText = useTimeTableColor(
		( state ) => state.updateFirstText
	);
	const updateSecondBG = useTimeTableColor(
		( state ) => state.updateSecondBG
	);
	const updateSecondText = useTimeTableColor(
		( state ) => state.updateSecondText
	);
	const updateEvenBG = useTimeTableColor( ( state ) => state.updateEvenBG );
	const updateEvenText = useTimeTableColor(
		( state ) => state.updateEvenText
	);
	const updateOddBG = useTimeTableColor( ( state ) => state.updateOddBG );
	const updateOddText = useTimeTableColor( ( state ) => state.updateOddText );
	const updateLightBG = useTimeTableColor( ( state ) => state.updateLightBG );
	const updateLightText = useTimeTableColor(
		( state ) => state.updateLightText
	);
	const updateBorderClr = useTimeTableColor(
		( state ) => state.updateBorderClr
	);
	const updateBorderSize = useTimeTableColor(
		( state ) => state.updateBorderSize
	);
	const updateBorderStyle = useTimeTableColor(
		( state ) => state.updateBorderStyle
	);

	const GetMetaThemeColors = ( meta ) => {
		if ( meta[ 'meta-key' ] === 'firstbg' ) {
			updateFirstBG( JSON.parse( meta.value.toString() ) );
		}
		
		if ( meta[ 'meta-key' ] === 'firstclr' ) {
			updateFirstText( JSON.parse( meta.value.toString() ) );
		} 
		

		if ( meta[ 'meta-key' ] === 'secondbg' ) {
			updateSecondBG( JSON.parse( meta.value.toString() ) );
		} 
		

		if ( meta[ 'meta-key' ] === 'secondclr' ) {
			updateSecondText( JSON.parse( meta.value.toString() ) );
		} 
		
		if ( meta[ 'meta-key' ] === 'evenbg' ) {
			updateEvenBG( JSON.parse( meta.value.toString() ) );
		} 
		if ( meta[ 'meta-key' ] === 'evenclr' ) {
			updateEvenText( JSON.parse( meta.value.toString() ) );
		}

		if ( meta[ 'meta-key' ] === 'oddbg' ) {
			updateOddBG( JSON.parse( meta.value.toString() ) );
		} 
		
		if ( meta[ 'meta-key' ] === 'oddclr' ) {
			updateOddText( JSON.parse( meta.value.toString() ) );
		}
		
		if ( meta[ 'meta-key' ] === 'highlightbg' ) {
			updateLightBG( JSON.parse( meta.value.toString() ) );
		}
		
		if ( meta[ 'meta-key' ] === 'highlightclr' ) {
			updateLightText( JSON.parse( meta.value.toString() ) );
		} 

		if ( meta[ 'meta-key' ] === 'borderclr' ) {
			updateBorderClr( JSON.parse( meta.value.toString() ) );
		}
		
		if ( meta[ 'meta-key' ] === 'bordersize' ) {
			updateBorderSize( JSON.parse( meta.value.toString() ) );
		} 
		
		if ( meta[ 'meta-key' ] === 'borderstyle' ) {
			updateBorderStyle( JSON.parse( meta.value.toString() ) );
		} 
	};
	return { GetMetaThemeColors };
};
